export default "__VITE_ASSET__CtAIxdxQ__"